import { useState, useRef } from "react";
import ReactPlayer from "react-player";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import "./PlayerYoutube.css";

const PlayerYoutube = ({ DefaultVideoId, DefaultVideoTitle }) => {
  const playerRef = useRef(null);
  const fullScreenHandle = useFullScreenHandle();

  const [playing, setPlaying] = useState(false);
  const [volume, setVolume] = useState(0.8);
  const [playbackRate, setPlaybackRate] = useState(1);
  const [duration, setDuration] = useState(0);
  const [played, setPlayed] = useState(0);

  const handleProgress = (state) => setPlayed(state.played);
  const handleDuration = (dur) => setDuration(dur);
  const handleSeek = (e) => playerRef.current.seekTo(parseFloat(e.target.value));

  const formatTime = (seconds) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = Math.floor(seconds % 60);
    return h > 0
      ? `${h}:${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`
      : `${m}:${s.toString().padStart(2, "0")}`;
  };

  return (
    <div className="player-wrapper">
      <h3 className="video-title d-none">{DefaultVideoTitle}</h3>

      <FullScreen handle={fullScreenHandle}>
        <div className="player-container">
          {/* YouTube Player */}
          <ReactPlayer
            ref={playerRef}
            className="react-player"
            url={`https://www.youtube.com/embed/${DefaultVideoId}`}
            width="100%"
            height="100%"
            playing={playing}
            volume={volume}
            playbackRate={playbackRate}
            onProgress={handleProgress}
            onDuration={handleDuration}
            controls={false}
            config={{
              youtube: {
                playerVars: {
                  rel: 0,
                  modestbranding: 1,
                  iv_load_policy: 3,
                  disablekb: 1,
                  autoplay: 0,
                  showinfo: 0,
                },
                embedOptions: { noCookie: true },
              },
            }}
          />

          {/* Click overlay to toggle play/pause */}
          <div
            className="click-overlay"
            onClick={() => setPlaying(!playing)}
          ></div>

          {/* Custom Controls */}
          <div className="custom-controls">
            <button onClick={() => setPlaying(!playing)}>
              {playing ? "⏸" : "▶️"}
            </button>
            <button
              onClick={() => {
                let t = playerRef.current.getCurrentTime() - 10;
                playerRef.current.seekTo(t > 0 ? t : 0);
              }}
            >
              ⏪
            </button>
            <button
              onClick={() => {
                let t = playerRef.current.getCurrentTime() + 10;
                playerRef.current.seekTo(t);
              }}
            >
              ⏩
            </button>

            <input
              type="range"
              min={0}
              max={1}
              step="any"
              value={volume}
              onChange={(e) => setVolume(parseFloat(e.target.value))}
              className="slider"
            />

            <select
              value={playbackRate}
              onChange={(e) => setPlaybackRate(parseFloat(e.target.value))}
            >
              <option value={0.5}>0.5x</option>
              <option value={0.75}>0.75x</option>
              <option value={1}>1x</option>
              <option value={1.25}>1.25x</option>
              <option value={1.5}>1.5x</option>
              <option value={2}>2x</option>
            </select>

            <span className="time">
              {formatTime(played * duration)} / {formatTime(duration)}
            </span>

            <input
              type="range"
              min={0}
              max={duration}
              step="any"
              value={played * duration}
              onChange={handleSeek}
              className="progress"
            />

            <button onClick={() => fullScreenHandle.enter()}>⛶</button>
          </div>
        </div>
      </FullScreen>
    </div>
  );
};

export default PlayerYoutube;
